/**
 * Every route that renders a ported board (build 7).
 *
 * The shell's "part sample" line (demo/platform/FeedNotice.tsx) shows on these
 * and nowhere else. It used to carry its own hand-kept list, which missed every
 * dashboard board that became a screen of its own — Executive KPIs, Store &
 * Warehouse, Sustainability, the certification boards — so those drew sample
 * figures on the live platform with nothing to say so.
 *
 * Now the dashboard's boards come from DASHBOARD_SCREENS, the same list the
 * router builds their routes from, and the few boards routed by hand are listed
 * here; `boardRoutes.test.ts` reads the router and fails if a board route is
 * missing from this list. No imports beyond that list, so the shell can read it
 * without loading a board.
 */
import { DASHBOARD_SCREENS } from "./dashboardScreens";

/** The boards the router mounts by hand (app/router.tsx), as paths without the leading slash. */
export const STANDALONE_BOARDS: readonly string[] = [
  "overview",
  "instruments",
  "stores",
  "drawing",
  "rubber",
  "friction",
  "buildings",
  "engineering",
  "projects",
  "assessments",
  "landside",
  "plans",
  "section-3d",
  "inspection-platform",
];

/** Every board route: the hand-mounted ones and each dashboard board. */
export const BOARD_ROUTES: ReadonlySet<string> = new Set([
  ...STANDALONE_BOARDS,
  ...DASHBOARD_SCREENS.map((d) => d.to.replace(/^\/+/, "")),
]);

/** True on a route that renders a ported board. */
export const isBoardRoute = (pathname: string): boolean =>
  BOARD_ROUTES.has(pathname.replace(/^\/+|\/+$/g, ""));
